import React, { useState, useEffect } from "react";
import API from "../../services/api";
import {
  SlSelect,
  SlOption,
  SlButton,
} from "@shoelace-style/shoelace/dist/react";
import { format, subMonths } from "date-fns";
import { Toast } from "../../shared/Toast";
import { getReportLastDay, getReportMonthTimestamps } from "./reportDateUtils";

function AlphaTeamReports(props) {
  const { year, month, newReports } = props;

  const [salesList, setSaleslist] = useState([]);
  const [reports, setReports] = useState([]);
  const [location, setLocation] = useState("");
  const [locations, setLocations] = useState([]);
  const [yearReport, setYearReport] = useState([]);
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month - 1));
  function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    return getReportMonthTimestamps(year, month);
  }
  function getPreviousMonthsLabels(currentMonth, year) {
    const months = [];
    let date = new Date(year, currentMonth - 2, 1);

    for (let i = 0; i < currentMonth - 1; i++) {
      months.push(format(date, "MMM_yy"));
      date = subMonths(date, 1);
    }

    return months;
  }
  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(
    year,
    month
  );

  const getLocations = async () => {
    const res = await API({
      url: `/alpha/getLocations`,
      method: "POST",
      responseType: "json",
      data: {},
    });
    if (res?.code === 200) {
      setLocations(res?.data);
    }
  };
  const getReports = async () => {
    const res = await API({
      url: `/alpha/getReports`,
      method: "POST",
      responseType: "json",
      data: {
        location: location,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        newReport: newReports,
      },
    });
    if (res?.code === 200) {
      setSaleslist(res?.data?.salesList);
      setReports(res?.data?.reports);
      setYearReport(res?.data?.yearReports);
    }
  };

  function getTotalSpent(sales_id, date) {
    const result = reports.find(
      (item) => item.sales_id === sales_id && item.date === date
    );
    return result ? result.totalSpent : ''; // Returns null if no matching data is found
  }

  function getTotalAds(sales_id, date) {
    const result = reports.find(
      (item) => item.sales_id === sales_id && item.date === date
    );
    return result ? result.adsCount : ''; // Returns null if no matching data is found
  }

  function calculateTotalSpent(date, sales_id, type = "date") {
    let totalSpent = 0;
    reports.map((item) => {
      if (type === "date") {
        if (item.date === date) totalSpent += item.totalSpent;
      } else if (type === "sales_id") {
        if (item.sales_id === sales_id) totalSpent += item.totalSpent;
      } else if (type === "total") {
        totalSpent += item.totalSpent;
      }
    });
    return totalSpent;
  }

  function calculateTotalAds(date, sales_id, type = "date") {
    let adsCount = 0;
    reports.map((item) => {
      if (type === "date") {
        if (item.date === date) adsCount += item.adsCount;
      } else if (type === "sales_id") {
        if (item.sales_id === sales_id) adsCount += item.adsCount;
      } else if (type === "total") {
        adsCount += item.adsCount;
      }
    });
    return adsCount;
  }

  const getTotalSpentForMonth = (monthNumber, sales_id, type='spent') => {
    // Find the corresponding month in the aggregation result
    const monthData = yearReport.find(
      (item) =>
        item.yearMonth === `${year}-${monthNumber}` &&
        item.sales_id === sales_id
    );

    // If month data is found, return the totalSpent, else return 0
    if(type === 'spent'){
      return monthData ? monthData.totalSpent : 0;
    }else if(type === 'ads'){
      return monthData ? monthData.adsCount : 0;
    }
  };

  const getMonthsTotal = (monthNumber, type='spent') => {
    // Find the corresponding month in the aggregation result
    let total = 0;
    yearReport.map(
      (item) => {
        if (type === 'spent') {
          if (item.yearMonth === `${year}-${monthNumber}`) {
            total +=  item.totalSpent;
          }
        } else if (type === 'ads') {
          if (item.yearMonth === `${year}-${monthNumber}`) {
            total +=  item.adsCount;
          }
        }
      }
    );
    return total;
  }
  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1);
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + times * 86400;
  };

  const sendWhatsAppReports = async () => {
    const res = await API({
      url: `/alpha/sendWhatsAppReports`,
      method: "POST",
      responseType: "json",
      data: {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        newReport: newReports,
        year: year,
        month: month,
      },
    });
    if (res?.code === 200) {
      Toast('success', "Reports sent successfully");
    }
  };

  useEffect(() => {
    getLocations();
  }, []);

  useEffect(() => {
    if (location) {
      getReports();
    }
  }, [location]);
  return (
    <>
      <div className="flex justify-between items-end mb-2 ">
        <h5>Alpha Team Reports</h5>
        <div className="flex items-center gap-2">
          <SlSelect
            className="w-44"
            value={location}
            onSlChange={(e) => setLocation(e.target.value)}
            size="small"
          >
            <SlOption value="">Select Location</SlOption>
            {locations?.map((item) => (
              <SlOption value={item.value}>{item.label}</SlOption>
            ))}
          </SlSelect>
          <SlButton
            variant="primary"
            size="small"
            onClick={sendWhatsAppReports}
          >
            Send Reports
          </SlButton>
        </div>
      </div>

      <table className="table table-bordered report-image alpha-reports text-center ">
        <thead>
          <tr className="bg-blue-500 text-white font-semibold">
            <th colSpan={99} className="text-center text-2xl">
              {" "}
              Alpha Sales - {format(new Date(year, month - 1), "MMMM")} - {year}{" "}
              - {locations.find((item) => item.value == location)?.label || ""}{" "}
            </th>
          </tr>

          <tr className="bg-blue-200">
            <th></th>
            <th
              colSpan={salesList.length * 2}
              className="capitalize text-center"
            >
              {locations.find((item) => item.value == location)?.label || ""}{" "}
            </th>
            <th colSpan={2}>Total</th>
          </tr>
          <tr className="bg-gray-100">
            <th>Date</th>
            {salesList.map((item) => (
              <th colSpan={2}>{item.name}</th>
            ))}
            <th colSpan={2}>POC's</th>
          </tr>
          <tr>
            <th>Date</th>
            {salesList.map((item) => (
              <>
                <th>No. of Ads</th>
                <th>Revenue </th>
              </>
            ))}
            <th>No. of Ads</th>
            <th>Revenue </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: currentDay }, (_, index) => (
            <tr key={index}>
              <td>{`${index + 1}-${format(
                new Date(year, month - 1),
                "MMM"
              )}-${year}`}</td>
              {salesList.map((item) => (
                <>
                  <td>{getTotalAds(item.sales_person_id, getTimestamp(index))}</td>
                  <td title={getTotalSpent(item.sales_person_id, getTimestamp(index)) || 0}>
                    {getTotalSpent(item.sales_person_id, getTimestamp(index)) !== '' ? Math.round(getTotalSpent(item.sales_person_id, getTimestamp(index))) : ''}
                  </td>
                </>
              ))}
              <td>{calculateTotalAds(getTimestamp(index))}</td>
              <td title={calculateTotalSpent(getTimestamp(index))}>{Math.round(calculateTotalSpent(getTimestamp(index)))}</td>
            </tr>
          ))}
          <tr className="bg-yellow-300">
            <td>Total</td>
            {salesList.map((item) => (
              <>
                <td>{calculateTotalAds(null,item.sales_person_id, "sales_id")}</td>
                <td title={calculateTotalSpent(null, item.sales_person_id, "sales_id")}>
                  {Math.round(calculateTotalSpent(null, item.sales_person_id, "sales_id"))}
                </td>
              </>
            ))}
            <td>{calculateTotalAds(null, null, 'total')}</td>
            <td title={calculateTotalSpent(null, null, "total")}>{Math.round(calculateTotalSpent(null, null, "total"))}</td>
          </tr>
          {getPreviousMonthsLabels(month, year).map((month_label, index) => (
            <tr key={`month-${index}`} className="bg-orange-50">
              <td>{month_label}</td>
              {salesList.map((item) => (
                <>
                  <td>{getTotalSpentForMonth(month-(index+1), item.sales_person_id, 'ads')}</td>
                  <td title={getTotalSpentForMonth(month - (index + 1), item.sales_person_id)}>
                    {Math.round(getTotalSpentForMonth(month - (index + 1), item.sales_person_id) || 0)}
                  </td>
                </>
              ))}
              <td>{getMonthsTotal(month-(index+1), 'ads')}</td>
              <td title={getMonthsTotal(month-(index+1), 'spent')}>{Math.round(getMonthsTotal(month-(index+1), 'spent'))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default AlphaTeamReports;
